import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {client} from "../_api/client";
import {errorConverterFields} from "../common/formater";
import {IDLE, LOADING, SUCCESS, FAILED} from "../common/statuses";


const COMMON = "common"
const initialState = {
    courses: {
        data: null,
        status: IDLE,
    },
    cities: {
        data: null,
        status: IDLE,
    },
    request: {
        errors: null,
        status: IDLE
    },
    teachers: {
        data: null,
        status: IDLE
    }
}

export const getCourses = createAsyncThunk(
    `${COMMON}/courses`,
    async () => {
        const response = await client.get("/course/all")
        return response.data
    }
)

export const getShortCourses = createAsyncThunk(
    `${COMMON}/courses`,
    async () => {
        const response = await client.get("/course/allShort")
        return response.data
    }
)

export const getCities = createAsyncThunk(
    `${COMMON}/cities`,
    async () => {
        const response = await client.get("/city/all")
        return response.data
    }
)

export const saveRequest = createAsyncThunk(
    `${COMMON}/request`,
    async (body) => {
        const {phoneNumber} = body
        const request = {
            ...body,
            phoneNumber: phoneNumber.match(/\d/g)
                ? phoneNumber.match(/\d/g).join("")
                : phoneNumber
        }
        const response = await client.post("/request", request)
        return response.data
    }
)

export const saveCollaborationRequest = createAsyncThunk(
    `${COMMON}/collaborationRequest`,
    async (body) => {
        const {phoneNumber} = body
        const request = {
            ...body,
            phoneNumber: phoneNumber.match(/\d/g)
                ? phoneNumber.match(/\d/g).join("")
                : phoneNumber
        }
        const response = await client.post("/request/collaboration", request)
        return response.data
    }
)

export const getAllCommonTeachers = createAsyncThunk(
    `${COMMON}/teachers`,
    async () => {
        const response = await client.get("/common/getAllTeachers")
        return response.data
    }
)

const commonService = createSlice({
    name: COMMON,
    initialState,
    reducers: {
        setEmpty: () => {
          return {...initialState}
        },
        removeCourses: (state) => {
            return {
                ...state,
                courses: {
                    data: null,
                    status: IDLE,
                },
            }
        },
        closeRequest: (state) => {
            return {
                ...state,
                cities: {
                    data: null,
                    status: IDLE,
                },
                request: {
                    errors: null,
                    status: IDLE
                }
            }
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getCourses.pending, (state) => {
                state.courses.status = LOADING
            })
            .addCase(getCourses.fulfilled, (state, action) => {
                state.courses.status = SUCCESS
                state.courses.data = action.payload
            })
            .addCase(getCourses.rejected, (state) => {
                state.courses.status = FAILED
            })

            .addCase(getCities.pending, (state) => {
                state.cities.status = LOADING
            })
            .addCase(getCities.fulfilled, (state, action) => {
                state.cities.status = SUCCESS
                state.cities.data = action.payload
            })
            .addCase(getCities.rejected, (state) => {
                state.cities.status = FAILED
            })

            .addCase(saveRequest.pending, (state) => {
                state.request.status = LOADING
                state.request.errors = null
            })
            .addCase(saveRequest.fulfilled, (state) => {
                state.request.status = SUCCESS
                state.request.errors = null
            })
            .addCase(saveRequest.rejected, (state, action) => {
                state.request.status = FAILED
                state.request.errors = errorConverterFields(action)
            })

            .addCase(saveCollaborationRequest.pending, (state) => {
                state.request.status = LOADING
                state.request.errors = null
            })
            .addCase(saveCollaborationRequest.fulfilled, (state) => {
                state.request.status = SUCCESS
                state.request.errors = null
            })
            .addCase(saveCollaborationRequest.rejected, (state, action) => {
                state.request.status = FAILED
                state.request.errors = errorConverterFields(action)
            })

            .addCase(getAllCommonTeachers.pending, (state) => {
                state.teachers.status = LOADING
            })
            .addCase(getAllCommonTeachers.fulfilled, (state, action) => {
                state.teachers.status = SUCCESS
                state.teachers.data = action.payload
            })
            .addCase(getAllCommonTeachers.rejected, (state) => {
                state.teachers.status = FAILED
            })
    }
})

export const {closeRequest, setEmpty, removeCourses} = commonService.actions

export default commonService.reducer